import { FC } from 'react';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { Category, Equipment } from '@/types';
import { COLORS } from '@/constants';
import { CheckboxGrid, OfferTypeList } from '../styled';

interface CheckboxListProps {
  items: Array<Category | Equipment>;
  selected: string[] | null;
  onToggle: (code: string, checked: boolean) => void;
  grid?: boolean;
}

export const CheckboxList: FC<CheckboxListProps> = ({ items, selected, onToggle, grid }) => {
  const Wrapper = grid ? CheckboxGrid : OfferTypeList;
  return (
    <Wrapper>
      {items.map((item) => (
        <FormControlLabel
          key={item.code}
          label={
            <Typography fontSize={14} color={COLORS['primary/900']}>
              {item.title || item.code}
            </Typography>
          }
          control={
            <Checkbox
              size="small"
              checked={selected !== null && selected.includes(item.code)}
              onChange={(e) => onToggle(item.code, e.target.checked)}
            />
          }
        />
      ))}
    </Wrapper>
  );
};
